<template>
   <div class="warning">
     <div class="message">
       <p>
          ‎Usamos cookies para armazenar informações sobre como você usa o nosso site. Tudo para tornar sua experiência a mais agradável possível. Ao clicar em 'Aceitar', você consente com a utilização de cookies.
          <a href="#/privacypolicy">Saiba-mais</a>
       </p>
     </div>
     <div class="button">
       <button class="btn btn-primary ml-2" @click="closeWarning()">Aceitar</button>
     </div>
   </div>
</template>

<script>

export default {
  name: 'LayoutWarningLGPD',
  methods: {
    setCookie (cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    },
    checkCookie (name) {
      const warning = document.querySelector('.warning')
      const cookie = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      if (cookie) {
        warning.classList.add('warning-close')
      } else {
        warning.classList.remove('warning-close')
      }
    },
    closeWarning () {
      const warning = document.querySelector('.warning')
      this.setCookie('Cookie', 'AlertCookie', '999')
      warning.classList.add('warning-close')
    }
  },
  mounted () {
    this.checkCookie('Cookie')
  }
}
</script>

<style lang="scss" scoped>
  .warning {
    width: 100%;
    background: #686868;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 35px;
    box-shadow: 0 -1px 10px 0 rgba(172, 171, 171, 0.3);
  }
  .warning-close {
    display: none;
  }
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 12px;
  }
  p {
    color: #ffffff;
    font-size: 15px;
    text-align: left;
  }
  a {
    color: #74baff;
  }
  button {
    padding: 7px 25px;
  }
</style>
